/**
 * A planning run as a dispatcher reads it, for every screen that names one.
 *
 * By its number, its horizon and its status in words. The planner's own
 * `label` (which layer wrote the run, from which parent run, over which dates)
 * and `planner_version` are written for whoever runs the planner, and the API
 * sends them for that reader; no screen shows them (UI review, 2 October 2026).
 * Not quoted here: this file reaches the bundle's source map, and
 * `npm run check:no-fixtures` rightly refuses a fixture value in it.
 */
import type { Run } from "./api";
import { formatShortDate } from "./time";

/** "Run 11, 1 Oct 2026 to 14 Oct 2026". */
export function runName(run: Run): string {
  return `Run ${run.run_id}, ${formatShortDate(run.horizon_start)} to ${formatShortDate(run.horizon_end)}`;
}

/** The solver's outcome. `optimal` and `feasible` are the only two in
 *  `transport.planning_runs` (read on 2 October 2026). */
const STATUS: Record<string, string> = {
  optimal: "Best plan found",
  feasible: "Plan found, not proven best",
};

/** The status in words; one this file does not know is still a word. */
export function runStatus(status: string): string {
  const known = STATUS[status];
  if (known) return known;
  const words = status.replace(/_/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
